/* olakina-gp-components.js
   GemPages のコンポーネントを自前実装で完全に置き換えるスクリプト。
   アコーディオン / カルーセル / ドット / カラースウォッチ / バリエーション / 数量 / カート追加
   外部CDNへの依存はゼロ。
*/
(function () {
  'use strict';

  function gpJSON(el, attr) {
    try { var r = el.getAttribute(attr); return r ? JSON.parse(r) : {}; } catch (e) { return {}; }
  }
  function device() {
    var w = window.innerWidth;
    return w <= 767 ? 'mobile' : (w <= 1024 ? 'tablet' : 'desktop');
  }
  function pick(v, fb) {
    if (v === null || v === undefined) return fb;
    if (typeof v !== 'object') return v;
    var d = device();
    if (v[d] !== undefined) return v[d];
    if (v.desktop !== undefined) return v.desktop;
    return fb;
  }
  function routeRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }
  function own(owner, sel) {
    return [].slice.call(owner.querySelectorAll(sel)).filter(function (e) {
      return e.closest('gp-product') === owner;
    });
  }
  /* overflow:hidden のコンテナではブラウザの behavior:'smooth' が無視される。
     そのため scrollLeft を自前で補間して動かす。 */
  function animateScroll(el, to, dur) {
    if (!el) return;
    to = Math.max(0, Math.min(to, el.scrollWidth - el.clientWidth));
    var from = el.scrollLeft, d = to - from;
    if (Math.abs(d) < 1) return;
    if (el.__okiRaf) { cancelAnimationFrame(el.__okiRaf); el.__okiRaf = null; }
    if (el.__okiTo) { clearTimeout(el.__okiTo); el.__okiTo = null; }
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (reduce || dur === 0 || document.hidden) { el.scrollLeft = to; return; }
    dur = dur || 320;
    var t0 = null, done = false;
    function ease(p) { return p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      el.scrollLeft = from + d * ease(p);
      if (p < 1) el.__okiRaf = requestAnimationFrame(step);
      else { el.scrollLeft = to; el.__okiRaf = null; done = true; }
    }
    el.__okiRaf = requestAnimationFrame(step);
    /* requestAnimationFrame が動かない環境（タブが非表示など）でも
       必ず目的の位置に到達させるための保険 */
    el.__okiTo = setTimeout(function () {
      if (!done) {
        if (el.__okiRaf) { cancelAnimationFrame(el.__okiRaf); el.__okiRaf = null; }
        el.scrollLeft = to;
      }
      el.__okiTo = null;
    }, dur + 120);
  }

  /* カラースウォッチの色指定（元のデザインの実測値）
     選択肢の名前に下のキーが含まれていれば、その色で丸を描く。
     色を足したいときはここに1行追加するだけでよい。 */
  var SWATCH_COLORS = {
    'オーシャンブルー': '#1F689E',
    'クラウドホワイト': '#FFFFFF',
    'スカイブルー': '#B5DBFA',
    'サンドベージュ': '#DCC095'
  };
  function swatchColor(name) {
    for (var k in SWATCH_COLORS) {
      if (SWATCH_COLORS.hasOwnProperty(k) && String(name).indexOf(k) > -1) return SWATCH_COLORS[k];
    }
    return null;
  }
  // Shopify CDN の画像URLから、サイズ指定を除いたファイル名を取り出す
  function normImg(u) {
    if (!u) return '';
    u = String(u).split('?')[0].split('/').pop();
    return u.replace(/_(\d+)?x(\d+)?(_crop_[a-z]+)?(@\d+x)?(?=\.)/i, '').toLowerCase();
  }
  // 選択中バリエーションの画像までギャラリーを送る
  function syncImage(prod, url, smooth) {
    var want = normImg(url);
    if (!want) return;
    prod.querySelectorAll('gp-product-images .gem-slider').forEach(function (track) {
      var items = [].slice.call(track.querySelectorAll('.gem-slider-item'));
      if (!items.length) return;
      for (var i = 0; i < items.length; i++) {
        var im = items[i].querySelector('img');
        if (im && normImg(im.getAttribute('src') || im.src) === want) {
          animateScroll(track, items[i].offsetLeft - items[0].offsetLeft, smooth ? 320 : 0);
          return;
        }
      }
    });
  }

  // "bg-1" のような設計トークン名を CSS 変数に変換する
  function token(v, fb) {
    if (!v || typeof v !== 'string') return fb;
    if (/^(bg|text|line|brand|highlight)(-\d)?$/.test(v)) return 'var(--g-c-' + v + ', ' + fb + ')';
    return v;
  }

  /* ======================= アコーディオン ======================= */
  function initAccordion(acc) {
    if (acc.dataset.okiAcc) return;
    acc.dataset.okiAcc = '1';
    var setting = gpJSON(acc, 'gp-data').setting || {};
    var single = setting.expandedMode !== 'multiple';
    var items = [].slice.call(acc.querySelectorAll('.gp-accordion-item'));
    if (!items.length) return;

    function setOpen(it, open) {
      var b = it.querySelector('.gp-accordion-item_body');
      var ic = it.querySelector('.gp-accordion-item_icon');
      var h = it.querySelector('.gp-accordion-item_header');
      if (b) { b.style.gridTemplateRows = open ? '1fr' : '0fr'; b.setAttribute('data-show', open ? 'true' : 'false'); }
      if (ic) ic.style.transform = open ? 'rotate(270deg)' : 'rotate(90deg)';
      if (h) h.setAttribute('aria-expanded', open ? 'true' : 'false');
      it.setAttribute('data-oki-open', open ? 'true' : 'false');
    }
    function toggle(it) {
      var open = it.getAttribute('data-oki-open') !== 'true';
      if (open && single) items.forEach(function (o) { if (o !== it) setOpen(o, false); });
      setOpen(it, open);
    }
    items.forEach(function (it, i) {
      var h = it.querySelector('.gp-accordion-item_header');
      if (!h) return;
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.style.cursor = 'pointer';
      h.addEventListener('click', function (e) { e.preventDefault(); toggle(it); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(it); }
      });
      // 初期状態はすべて閉じる（元設定の activeKey は意図的に無視している）
      setOpen(it, false);
    });
  }

  /* ======================= カルーセル ======================= */
  function initCarousel(car) {
    if (car.dataset.okiCar) return;
    var track = car.querySelector('.gem-slider');
    if (!track) return;
    var items = [].slice.call(track.querySelectorAll('.gem-slider-item'));
    if (items.length < 2 || !track.clientWidth) return;
    car.dataset.okiCar = '1';

    var setting = gpJSON(car, 'gp-data').setting || {};
    var loop = !!pick(setting.loop, false);
    var prev = car.querySelector('.gem-slider-previous');
    var next = car.querySelector('.gem-slider-next');

    // 各スライドのトラック内 X 座標（余白やギャップがあっても正確に求まる）
    function offsets() {
      var base = items[0].offsetLeft;
      return items.map(function (it) { return it.offsetLeft - base; });
    }
    function perPage() {
      var o = offsets();
      var w = (o.length > 1 ? (o[1] - o[0]) : 0) || items[0].getBoundingClientRect().width || track.clientWidth;
      return Math.max(1, Math.round(track.clientWidth / w));
    }
    function nearest() {
      var o = offsets(), cur = track.scrollLeft, best = 0, bd = Infinity;
      for (var i = 0; i < o.length; i++) {
        var d = Math.abs(o[i] - cur);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }
    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function goIndex(i, smooth) {
      var o = offsets();
      var last = o.length - 1;
      if (i < 0) i = loop ? last : 0;
      if (i > last) i = loop ? 0 : last;
      animateScroll(track, Math.min(o[i], maxScroll()), smooth === false ? 0 : 320);
      return i;
    }
    function step(dir) { goIndex(nearest() + dir * perPage()); }

    function refresh() {
      if (loop) return;
      var s = track.scrollLeft <= 2, e = track.scrollLeft >= maxScroll() - 2;
      [[prev, s], [next, e]].forEach(function (p) {
        if (!p[0]) return;
        p[0].style.opacity = p[1] ? '0.35' : '';
        p[0].setAttribute('aria-disabled', p[1] ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
    track.addEventListener('scroll', function () { clearTimeout(track.__t); track.__t = setTimeout(refresh, 80); }, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();

    /* ---- ドラッグ / スワイプ ---- */
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    function end() {
      if (!down) return;
      down = false;
      if (!moved) return;
      goIndex(nearest());   // 必ずスライドの境界に吸着させる
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) { track.addEventListener(t, end); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.style.touchAction = 'pan-y';
    car.__okiSnap = function () { goIndex(nearest(), false); };
  }

  /* ======================= 数量 ======================= */
  function initQty(q) {
    if (q.dataset.okiQty) return;
    q.dataset.okiQty = '1';
    var input = q.querySelector('input[name="quantity"]') || q.querySelector('input');
    if (!input) return;
    var btns = q.querySelectorAll('button');
    function set(n) {
      input.value = Math.max(1, n || 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (btns[0]) btns[0].addEventListener('click', function (e) { e.preventDefault(); set((parseInt(input.value, 10) || 1) - 1); });
    if (btns[1]) btns[1].addEventListener('click', function (e) { e.preventDefault(); set((parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('blur', function () { set(parseInt(input.value, 10) || 1); });
  }

  /* ======================= 商品 ======================= */
  function initProduct(prod) {
    if (prod.dataset.okiProd) return;
    prod.dataset.okiProd = '1';

    var ctx = gpJSON(prod, 'gp-context');
    var pid = ctx.productId;
    var variants = [];
    var sc = pid ? document.querySelector('script[data-oki-variants="' + pid + '"]') : null;
    if (sc) { try { variants = (JSON.parse(sc.textContent) || {}).variants || []; } catch (e) {} }

    var radios = own(prod, 'input[type="radio"][name*="-options-"]');
    var order = [], seen = {};
    radios.forEach(function (r) { if (!seen[r.name]) { seen[r.name] = 1; order.push(r.name); } });

    function selected() {
      return order.map(function (n) {
        var hit = radios.filter(function (r) { return r.name === n && r.checked; })[0];
        return hit ? hit.value : null;
      });
    }
    function findVariant() {
      var sel = selected();
      if (!variants.length) return ctx.variantSelected || null;
      if (!sel.length || sel.indexOf(null) > -1) return ctx.variantSelected || variants[0];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (String((v.options || [])[j]) !== String(sel[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* 元のマークアップには既に色の丸（div.color）と外側のリングがある。
       サイズだけ CSS で与え、色が入っていない場合のみ補う。 */
    function buildSwatches() {
      var groups = own(prod, '.variant-inside');
      groups.forEach(function (g, gi) {
        var labels = [].slice.call(g.querySelectorAll('label.option-item'));
        if (!labels.length) return;
        var wrap = g.querySelector('.variant-option-group') || labels[0].parentNode;
        var isSwatch = labels.every(function (l) { return !l.querySelector('.option-value'); });
        if (!isSwatch) {
          if (wrap) wrap.classList.add('oki-text-group');   // サイズなどの文字表示
          return;
        }
        if (wrap) wrap.classList.add('oki-swatch-group');
        labels.forEach(function (l) {
          var input = l.querySelector('input');
          var box = l.querySelector('div.color');
          if (!input || !box) return;
          var val = input.value;
          box.setAttribute('title', val);
          var cur = '';
          try { cur = getComputedStyle(box).backgroundColor; } catch (e) {}
          var empty = !cur || cur === 'transparent' || cur.replace(/\s/g, '') === 'rgba(0,0,0,0)';
          if (!empty) return;                                // 元の色が入っていればそのまま使う
          var col = swatchColor(val);
          if (col) { box.style.background = col; return; }
          for (var i = 0; i < variants.length; i++) {
            if (String((variants[i].options || [])[gi]) === String(val) && variants[i].image) {
              box.style.background = '#fff';
              box.style.backgroundImage = 'url(' + variants[i].image + ')';
              box.style.backgroundSize = 'cover';
              box.style.backgroundPosition = 'center';
              return;
            }
          }
        });
      });
    }

    function markSelected() {
      own(prod, 'label.option-item').forEach(function (l) {
        var input = l.querySelector('input');
        var on = !!(input && input.checked);
        l.setAttribute('data-oki-selected', on ? 'true' : 'false');
        var ring = l.querySelector('.option-item-inner > div');
        if (ring && l.querySelector('div.color')) {
          ring.style.setProperty('border-color', on ? '#121212' : 'transparent', 'important');
        }
      });
    }

    var firstApply = true;
    function apply() {
      var v = findVariant();
      prod.setAttribute('data-oki-variant', (v && v.id) ? v.id : '');
      markSelected();

      own(prod, 'gp-product-price .gp-price').forEach(function (el) {
        if (!v) return;
        var isCmp = el.classList.contains('gp-product-compare-price');
        var wrap = el.closest('gp-product-price');
        if (isCmp) {
          var show = v.compare_at_price && v.compare_at_price > v.price;
          if (wrap) wrap.style.display = show ? '' : 'none';
          if (show && v.compare_f) el.textContent = v.compare_f;
        } else if (v.price_f) {
          el.textContent = v.price_f;
        }
      });

      // スウォッチの選択肢は、見出しの横に選択中の値を出す
      own(prod, '.variant-inside').forEach(function (g, gi) {
        if (!g.querySelector('div.color')) return;   // 色の選択肢だけ
        var lg = g.querySelector('.variant-display');
        if (!lg) return;
        var sp = lg.querySelector('.oki-opt-value');
        if (!sp) { sp = document.createElement('span'); sp.className = 'oki-opt-value'; lg.appendChild(sp); }
        var cur = (v && v.options) ? v.options[gi] : '';
        sp.textContent = cur ? '：' + cur : '';
      });

      // 選択に合わせて商品画像を切り替える
      if (v && v.image) { syncImage(prod, v.image, !firstApply); }
      firstApply = false;

      own(prod, 'gp-product-button').forEach(function (pb) {
        var btn = pb.querySelector('button[name="add"]') || pb.querySelector('button');
        if (!btn) return;
        var label = btn.querySelector('[data-gp-text]');
        var avail = v ? v.available !== false : false;
        btn.disabled = !avail;
        btn.setAttribute('data-state', avail ? 'idle' : 'disabled');
        btn.style.opacity = avail ? '' : '0.5';
        btn.style.cursor = avail ? '' : 'not-allowed';
        if (label) {
          if (!btn.dataset.okiLabel) btn.dataset.okiLabel = label.textContent;
          var out = pb.getAttribute('gp-label-out-of-stock');
          label.textContent = avail ? btn.dataset.okiLabel : (out || btn.dataset.okiLabel);
        }
      });
    }

    /* URL に ?variant= が無いときは、先頭の購入可能なバリエーションを既定にする
       （この商品ではバスタオル／海（オーシャンブルー）になる） */
    function applyDefault() {
      if (!radios.length || !variants.length) return;
      try { if (new URLSearchParams(location.search).get('variant')) return; } catch (e) {}
      var first = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available !== false) { first = variants[i]; break; }
      }
      if (!first) first = variants[0];
      order.forEach(function (n, gi) {
        var want = String((first.options || [])[gi]);
        radios.forEach(function (r) {
          if (r.name === n) r.checked = (String(r.value) === want);
        });
      });
    }

    buildSwatches();
    applyDefault();
    radios.forEach(function (r) { r.addEventListener('change', apply); });
    apply();
  }

  /* ======================= カートに追加 ======================= */
  function initAddButton(pb) {
    if (pb.dataset.okiBtn) return;
    pb.dataset.okiBtn = '1';
    var prod = pb.closest('gp-product');
    var href = pb.getAttribute('gp-href') || (routeRoot() + 'cart');
    var btn = pb.querySelector('button[name="add"]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var id = prod ? prod.getAttribute('data-oki-variant') : '';
      if (!id && prod) {
        var c = gpJSON(prod, 'gp-context');
        id = (c.variantSelected && c.variantSelected.id) ? c.variantSelected.id : '';
      }
      if (!id) {
        var msg = pb.getAttribute('data-variant-selection-required-message');
        if (msg) alert(msg);
        return;
      }
      var qty = 1;
      var qi = prod ? prod.querySelector('gp-product-quantity input[name="quantity"]') : null;
      if (qi) qty = Math.max(1, parseInt(qi.value, 10) || 1);

      btn.setAttribute('data-state', 'loading');
      btn.disabled = true;

      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error((j && j.description) || 'error'); });
        return r.json();
      }).then(function () {
        window.location.href = href;
      }).catch(function (err) {
        btn.setAttribute('data-state', 'idle');
        btn.disabled = false;
        alert((err && err.message) ? err.message : 'カートに追加できませんでした。時間をおいて再度お試しください。');
      });
    });
  }


  /* ======================= 商品ギャラリー（サムネイルのクリック） ======================= */
  function initGallery(gal) {
    if (gal.dataset.okiGal) return;
    gal.dataset.okiGal = '1';

    // メイン表示は「一番大きいスライドを持つトラック」。都度判定する
    function mainTrack() {
      var best = null, bw = -1;
      [].slice.call(gal.querySelectorAll('.gem-slider')).forEach(function (t) {
        var it = t.querySelector('.gem-slider-item');
        var w = it ? it.getBoundingClientRect().width : 0;
        if (w > bw) { bw = w; best = t; }
      });
      return best;
    }

    gal.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var img = (t.tagName === 'IMG') ? t : t.closest('img');
      if (!img) {
        /* サムネイルは img の上にオーバーレイの div が重なっていて
           クリックの当たり先が img にならない。囲みの要素から拾う */
        var cell = t.closest('.gp-image-item, .gem-slider-item');
        if (cell) img = cell.querySelector('img');
      }
      if (!img) return;

      var main = mainTrack();
      if (!main || main.contains(img)) return;      // メイン画像自体のクリックは無視

      var items = [].slice.call(main.querySelectorAll('.gem-slider-item'));
      if (!items.length) return;
      var want = normImg(img.getAttribute('src') || img.src);
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        var mi = items[i].querySelector('img');
        if (mi && normImg(mi.getAttribute('src') || mi.src) === want) { idx = i; break; }
      }
      if (idx < 0) return;

      e.preventDefault();
      e.stopPropagation();

      var target = items[idx];
      animateScroll(main, target.offsetLeft - items[0].offsetLeft, 320);
      var box = main.getBoundingClientRect();
      if (box.bottom < 80 || box.top > window.innerHeight * 0.7) {
        try { main.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e3) {}
      }
    }, true);
  }

  /* ======================= 起動 ======================= */
  function run() {
    document.querySelectorAll('gp-accordion').forEach(initAccordion);
    document.querySelectorAll('gp-carousel').forEach(initCarousel);
    document.querySelectorAll('gp-product').forEach(initProduct);
    document.querySelectorAll('gp-product-quantity').forEach(initQty);
    document.querySelectorAll('gp-product-button').forEach(initAddButton);
    document.querySelectorAll('gp-product-images').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', function () {
    clearTimeout(window.__okiT);
    window.__okiT = setTimeout(function () {
      run();
      document.querySelectorAll('gp-carousel').forEach(function (c) { if (c.__okiSnap) c.__okiSnap(); });
    }, 200);
  });
  document.addEventListener('shopify:section:load', run);
})();
